'use client'

import React, { forwardRef, memo, useImperativeHandle } from 'react'
import { zodResolver } from '@hookform/resolvers/zod'
import { emailSchema, TEmailSchema, userIsLoggedInSelector } from '@segway/core'
import { useAppSelector } from '@segway/core/src/store/hooks'
import { useForm } from 'react-hook-form'

import { Form, FormControl, FormField, FormItem, FormMessage, Input } from '@/ui'

/**
 * 结算页游客 pickup 邮件
 *
 */

export interface GuestPickupEmailRef {
  handleSubmit: (cb: (values: TEmailSchema) => void) => void
}

const GuestPickupEmail = forwardRef<GuestPickupEmailRef>(({}, ref) => {
  const form = useForm<TEmailSchema>({
    resolver: zodResolver(emailSchema),
    defaultValues: {
      email: '',
    },
  })
  const isLoggedIn = useAppSelector(userIsLoggedInSelector)

  useImperativeHandle(ref, () => ({
    handleSubmit: (cb: (values: TEmailSchema) => void) => {
      form.handleSubmit(cb)()
    },
  }))

  return isLoggedIn ? null : (
    <div className="rounded-[12px] bg-white py-2">
      <Form {...form}>
        <form>
          <FormField
            control={form.control}
            name="email"
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <Input label="Email" {...field} required />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </form>
      </Form>
    </div>
  )
})

GuestPickupEmail.displayName = 'GuestPickupEmail'

export default memo(GuestPickupEmail)
